import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2 } from '@angular/core'

import { ITrack } from '../../../Interface/track'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ShareTrackPopupService } from '../../../services/share-track-popup.service'
import { BtnClassNameType, IconButtonSize } from '../button.types'

@Component({
  selector: 'bmcore-share-btn',
  templateUrl: './bmcore-share-btn.component.html',
  styleUrls: ['./bmcore-share-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreShareBtnComponent implements OnInit {
  @Input() track: ITrack
  @Input() parentComponent: 'player' | 'track-item' | 'track-mob-controls'

  @Input() showIconBtnVariant = false
  @Input() iconButtonSize: IconButtonSize
  @Input() iconSize = 24

  lg: LgType

  constructor(
    private i18nService: I18nService,
    private shareTrackPopupService: ShareTrackPopupService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  openPopup(event: MouseEvent) {
    // No parent scroll on modal scroll
    this.renderer.addClass(document.body, 'modal-open')

    event.stopPropagation()
    this.shareTrackPopupService.open(this.track)
  }

  getIconBtnVariant(): BtnClassNameType {
    return `icon-${this.iconButtonSize}`
  }
}
